import { FormFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";

export const fields: FormFields = [
  {
    name: "name",
    title: $t("Name")
  },
  {
    name: "amount",
    type: "amount",
    title: `${$t("Amount")}, ${$t("Credits")}`,
    rules: [
      v => !isNaN(Number(v)) || $t("{0} should be number", [$t("Amount")]),
      v => v === null || v === "" || Number(v) > 0 || $t("{0} can't be zero", [$t("Amount")])
    ]
  }
];
export default fields;
